<div class="modal-header">
    <h1 mat-dialog-title>{{title}}</h1>
</div>

<div *ngIf="action !== 'delete'; else deleteTemplate" mat-dialog-content>
    <form [formGroup]="formData" class="modal-form">

                <!-- Nome -->
                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="name" />

                    <mat-error *ngIf="formData.get('name')?.hasError('required') && formData.get('name')?.touched">
                        Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <!-- Descrizione -->
                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Descrizione</mat-label>
                    <textarea matInput formControlName="description" rows="4"></textarea>
                    <mat-error *ngIf="formData.get('description')?.invalid && formData.get('description')?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <!-- Trigger Type -->
                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Condizione di attivazione</mat-label>
                    <mat-select formControlName="triggerType" panelClass="custom-select-panel">
                        <mat-option value="ALWAYS">Attiva Sempre</mat-option>
                        <mat-option value="KEYWORDS">Parole Chiave</mat-option>
                        <mat-option value="REGEX">Espressione Regolare</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formData.get('triggerType')?.invalid && formData.get('triggerType')?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

            <!-- Conditional field: KEYWORDS -->
                <div *ngIf="formData.get('triggerType')?.value === 'KEYWORDS'">
                    <div *ngIf="!isLoading; else loading" class="keyword-section">

                        <div formArrayName="extraInputKeywordArray" class="keyword-list">
                            <div *ngFor="let extra of extraInputs.controls; let i = index" [formGroupName]="i" class="keyword-row">
                                <mat-form-field appearance="fill" class="keyword-input">
                                    <mat-label>Parola Chiave</mat-label>
                                    <input matInput formControlName="keyword" />
                                </mat-form-field>

                                <div class="keyword-remove">
                                    <button type="button" mat-icon-button color="warn" class="keyword-delete-btn" matTooltip="Elimina parola chiave" aria-label="Elimina parola chiave" (click)="removeExtraInput(i)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button class="btn-primary" (click)="addExtraInput()" matTooltip="Aggiungi parola chiave" aria-label="Aggiungi parola chiave">
                        <mat-icon>add</mat-icon>
                        Aggiungi
                    </button>

                    <ng-template #loading>
                        <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
                    </ng-template>
                </div>
                                        
            <!-- Conditional field: REGEX -->
             <div *ngIf="formData.get('triggerType')?.value === 'REGEX'">
                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Regex</mat-label>
                    <input matInput formControlName="regexText">
                </mat-form-field>
             </div>
                

            <!-- Provider Type -->
                <mat-form-field appearance="fill" class="full-width mt-12">
                    <mat-label>Tipo di provider</mat-label>
                    <mat-select formControlName="providerType" panelClass="custom-select-panel">
                        <mat-option value="EXTERNAL">Esterno</mat-option>
                        <mat-option value="INTERNAL">Interno</mat-option>
                    </mat-select>
                    <mat-error *ngIf="formData.get('providerType')?.invalid && formData.get('providerType')?.touched">Il campo è obbligatorio
                    </mat-error>
                </mat-form-field>

                <!-- Conditional field: URL -->
                <div *ngIf="formData.get('providerType')?.value === 'EXTERNAL'">
                    <mat-form-field appearance="fill" class="full-width mt-12">
                        <mat-label>URL</mat-label>
                        <input matInput formControlName="url" />

                        <mat-error *ngIf="formData.get('url')?.hasError('required') && formData.get('url')?.touched">
                            Il campo è obbligatorio
                        </mat-error>
                   </mat-form-field>
                </div>

                <!-- Conditional field: Alias -->
                 <div *ngIf="formData.get('providerType')?.value === 'INTERNAL'">
                    <mat-form-field appearance="fill" class="full-width mt-12">
                        <mat-label>Alias</mat-label>
                        <mat-select formControlName="aliasId" panelClass="custom-select-panel">
                            <mat-option *ngFor="let opt of selectAliasOptions" [value]="opt.value">{{opt.label}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="formData.get('aliasId')?.invalid && formData.get('aliasId')?.touched">Il campo è obbligatorio
                        </mat-error>
                    </mat-form-field>
                 </div>
                
                <!-- Conditional field: Metadati -->
                <mat-checkbox *ngIf="formData.get('providerType')?.value === 'INTERNAL'" formControlName="flagMetadati">
                    Includi tutti i valori dei metadati nei risultati
                </mat-checkbox>

            <!-- Size -->    
            <mat-form-field appearance="fill" class="full-width mt-12">
                <mat-label>Risultati della ricerca</mat-label>
                <mat-select formControlName="size" panelClass="custom-select-panel">
                    <mat-option *ngFor="let n of size" [value]="n.value">{{n.label}}</mat-option>
                        
                </mat-select>
                <mat-error *ngIf="formData.get('size')?.invalid && formData.get('size')?.touched">Il campo è obbligatorio
                </mat-error>
            </mat-form-field>

    </form>
</div>

<ng-template #deleteTemplate>
   <app-delete-modal [data]="data"></app-delete-modal>
</ng-template>

<div mat-dialog-actions class="button-actions">
    <button mat-stroked-button class=" btn-outlined-primary" (click)="onModalClose()" matTooltip="Annulla" aria-label="Annulla">Annulla</button>
    <button mat-flat-button color="primary" class="btn-primary" [disabled]="formData.invalid && action !== 'delete'" (click)="onModalSave()" [matTooltip]="action === 'delete' ? 'Conferma' : 'Salva'" [attr.aria-label]="action === 'delete' ? 'Conferma' : 'Salva'">
        {{action === 'delete' ? 'Conferma' : 'Salva'}}
    </button>
</div>
